export default "__VITE_ASSET__BnvMZBd5__"